export default {
	module: 'notifications',
	actions: {
		list: true,
		create: true,
		dynamicPaths: [
			{
				paths: {
					'/notifications/edit/:id': true,
				},
				keys: {
					':id': 3
				}
			}
		]
	}
}
